import axios from "axios";


let serverGetData = null;
if (typeof window === "undefined") {
    try {
        serverGetData = require("../pages/api/events/[startDate]").getData;
    } catch (e) {
        serverGetData = null;
    }
}

export const getDataAgenda = async () => {
  const { data } = await fetchDataAgenda();
  return data ? data : null;
};

const fetchDataAgenda = async () => {
    try {
        const { data } = await axios.get("https://www.clarin.com/agenda-deportiva/json/agenda.json");

        return {
        code: 200,
        data: data ?? {},
        error: null,
        };
    } catch (error) {
        return false;
    }
};


export const getAgendaEventSortKey = (fechaEvento, fechaGrupo) => {
    const [datePart, timePart = '00:00:00'] = fechaEvento.split(' ');
    const [hours, minutes] = timePart.split(':').map(Number);

    // Partidos de madrugada (00:00-05:59) del día siguiente pertenecen a la agenda del día anterior
    if (datePart > fechaGrupo && hours < 6) {
        return hours * 60 + minutes;
    }

    return hours * 60 + minutes;
};

export const sortAgendaEventos = (eventos, fechaGrupo) => {
    return [...eventos].sort((a, b) => {
        const keyA = getAgendaEventSortKey(a.fecha, fechaGrupo);
        const keyB = getAgendaEventSortKey(b.fecha, fechaGrupo);
        if (keyA !== keyB) return keyA - keyB;
        return new Date(a.fecha) - new Date(b.fecha);
    });
};

export const convertToLocalTimezone = (startDate, timezone) => {
    // Convertir la fecha a la timezone del contexto
    const eventDate = new Date(startDate);
    const localDateString = eventDate.toLocaleString("en-US", {
        timeZone: timezone
    });
    const localDate = new Date(localDateString);

    // Formatear fecha y hora en la timezone local
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    const seconds = String(localDate.getSeconds()).padStart(2, '0');

    const startDateStr = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    const fechaStr = `${year}-${month}-${day}`; // YYYY-MM-DD

    return { startDateStr, fechaStr };
};

export const getDataAgendaLila = async (query) => {
    const today = new Date();
    const startDate = today.getFullYear().toString() + String(today.getMonth() + 1).padStart(2, '0') + String(today.getDate()).padStart(2, '0');
    try {
        // Si tenemos la función server disponible (código server-side)
        if (serverGetData) {
            const res = await serverGetData(startDate);
            const content = res?.data ?? [];
            return parseDataAgenda(content);
        }

        const response = await fetch(`/api/events/${startDate}`);
        if (!response.ok) {
            return parseDataAgenda([]);
        }
        const json = await response.json();
        const content = json?.data ?? [];
        return parseDataAgenda(content);
    } catch (error) {
        return parseDataAgenda([]);
    }
}

export const parseDataAgenda = (content) => {
    const data = content?.data || content;
    if(!data || !Array.isArray(data)){
        return {
            fechas: [],
            canales: [],
            hoy: new Date().toISOString().split('T')[0],
        }
    }
    let newFormatData = data
        .filter((item) => {
            return item?.sections?.[0]?.name
                ?.toLowerCase()
                ?.includes("argentina");
        })
        .sort((a, b) => {
            const dateA = new Date(a.startDate);
            const dateB = new Date(b.startDate);
            return dateA - dateB;
        });

    const fechasMap = new Map();
    const canalesSet = new Set();

    const inicioHoyAR = new Date();
    inicioHoyAR.setHours(0, 0, 0, 0);
    const timezone = "America/Argentina/Buenos_Aires";
    // Procesar cada evento
    newFormatData.forEach((event) => {
        const { startDateStr, fechaStr } = convertToLocalTimezone(event.startDate, timezone);

        if (new Date(startDateStr) < inicioHoyAR) {
            return;
        }

        // Agregar canales al set
        event.tagsChannel?.forEach((channel) => {
            canalesSet.add({
                id: channel._id,
                nombre: channel.name,
            });
        });

        let sportName = event.sections?.[event.sections.length - 1]?.name
            ?.split('-')?.[1]
            ?.trim();
        const normalizedSportName = normalizeString(sportName);

        let teams = [];
        if (event?.related?.mams?.[0]?._id) {
            if (normalizedSportName === 'tenis') {
                teams = {
                    home: event?.related?.mams?.[0]?.value?.teams?.home?.players || [],
                    away: event?.related?.mams?.[0]?.value?.teams?.away?.players || []
                };
            } else {
                teams = {
                    home: [{ ...event?.related?.mams?.[0]?.value?.teams?.home }] || [],
                    away: [{ ...event?.related?.mams?.[0]?.value?.teams?.away }] || []
                };
            }
        } else {
            const separators = [
                ' - ',
                ' │ ',
                ' vs. ',
                ' vs ',
                ' | ',
                ' v. ',
            ];
            for (const key in separators) {
                const separator = separators[key];
                const tempTeams = event.title.split(separator);
                if (tempTeams.length === 2) {
                    teams = {
                        home: [{ name: tempTeams[0] }],
                        away: [{ name: tempTeams[1] }]
                    };
                    break;
                }
            }
            if (!teams || Object.keys(teams).length === 0) {
                teams = {
                home: [{name: event.title}],
                away: []
                };
            }
        }
        // Crear objeto evento en formato viejo
        const eventoViejo = {
            id: event._id,
            fecha: startDateStr,
            nombre: event.title,
            horaDia: getHoraDia(startDateStr),
            canales:
                event.tagsChannel?.map((channel) => ({
                    id: channel._id,
                    nombre: channel.name,
                })) || [],
            deporte: {
                nombre: sportName ?? '',
                icono: `${normalizedSportName}.png`,
            },
            mamId: event?.related?.mams?.[0]?._id || null,
            mamHomeId: event?.related?.mams?.[0]?.value?.teams?.home?._id ?? '',
            mamAwayId: event?.related?.mams?.[0]?.value?.teams?.away?._id ?? '',
            teams,
            fijado: event?.fixed,
            destacado: event?.rating,
            url: event?.url || '',
            orderTagsEventMetadata: Number.isFinite(Number(event?.tagsEvent?.metadata?.order))
                ? Number(event?.tagsEvent?.metadata?.order)
                : null,
            startDateUTC: event.startDate,	
        };

        // Agrupar por fecha
        if (!fechasMap.has(fechaStr)) {
            fechasMap.set(fechaStr, {
                fecha: fechaStr,
                torneos: new Map(),
                eventos: [],
                tieneEventos: true,
            });
        }

        const fechaData = fechasMap.get(fechaStr);
        const torneoNombre = event.tagsEvent?.name || 'Sin torneo';
        const torneoId = event.tagsEvent?._id || 'default';
        const torneoImage = event.tagsEvent?.related?.image?.[0] || '';

        // Agrupar por torneo
        if (!fechaData.torneos.has(torneoId)) {
            fechaData.torneos.set(torneoId, {
                id: torneoId,
                nombre: torneoNombre,
                eventos: [],
                deporte: eventoViejo.deporte,
                primerFecha: eventoViejo.fecha,
                image: torneoImage,
            });
        }

        fechaData.torneos.get(torneoId).eventos.push(eventoViejo);
    });

    // Convertir Map a Array y ordenar
    const fechasArray = Array.from(fechasMap.values())
        .map((fecha) => ({
            ...fecha,
            torneos: Array.from(fecha.torneos.values())
                .map((torneo) => ({
                    ...torneo,
                    eventos: sortAgendaEventos(torneo.eventos, fecha.fecha),
                }))
                .sort((a, b) => {
                    const getMinSortKey = (torneo) => {
                        const keys = (torneo?.eventos ?? []).map((evento) =>
                            getAgendaEventSortKey(evento.fecha, fecha.fecha)
                        );
                        return keys.length > 0 ? Math.min(...keys) : Infinity;
                    };

                    const sortKeyA = getMinSortKey(a);
                    const sortKeyB = getMinSortKey(b);
                    if (sortKeyA !== sortKeyB) {
                        return sortKeyA - sortKeyB;
                    }

                    const getOrderTagsEventMetadata = (torneo) => {
                        const orders = (torneo?.eventos ?? [])
                            .map((evento) => evento?.orderTagsEventMetadata)
                            .filter((order) => (order !== null && order !== undefined));

                        return orders.length > 0 ? Math.min(...orders) : null;
                    };

                    const orderA = getOrderTagsEventMetadata(a);
                    const orderB = getOrderTagsEventMetadata(b);
                    const hasOrderA = orderA !== null;
                    const hasOrderB = orderB !== null;

                    if (hasOrderA && hasOrderB) {
                        return orderA - orderB;
                    }

                    if (hasOrderA) {
                        return -1;
                    }

                    if (hasOrderB) {
                        return 1;
                    }

                    return new Date(a.primerFecha) - new Date(b.primerFecha);
                }),
        }))
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

    return {
        fechas: fechasArray,
        canales: Array.from(canalesSet).sort((a, b) =>
            a.nombre.localeCompare(b.nombre)
        ),
        hoy: new Date().toISOString().split('T')[0],
        firma: {
            mail: 'agenda@ole.com.ar',
            nombre: 'Agenda Deportiva Olé',
        },
    };
};

const getHoraDia = (date) => {
    const hour = parseInt(date.split(' ')[1].split(':')[0]);
    if (hour >= 6 && hour < 14) return 1; // Mañana
    if (hour >= 14 && hour < 20) return 2; // Tarde
    return 3; // Noche
};

export const normalizeString = (str) => {
    if (!str) return '';
    return str
        .normalize('NFD') // Descompone caracteres acentuados
        .replace(/[\u0300-\u036f]/g, '') // Elimina los diacríticos
        .toLowerCase() // Convierte a minúsculas
        .trim(); // Elimina espacios al inicio y final
};

const fetchData = async (url, options = {}, timeout = 10000) => {
    console.log("FEEtching DATAAAAA:", url);
    const controller = new AbortController();
    const signal = controller.signal;
    const timeoutId = setTimeout(() => controller.abort(), timeout);
    try {
        const response = await fetch(`${process.env.NEXT_PUBLIC_DOMAIN_URL}${url}`, { signal, ...options });
        const data = await response.json();
        return {
            code: 200,
            data: data,
            error: null,
        };
    } catch (error) {
        console.error("Error fetching data:", error);
        return {
            code: error?.code ?? 500,
            data: null,
            error: error?.message ?? "Internal Server Error",
        };
    } finally {
        clearTimeout(timeoutId);
    }
};